import {ICashierExternalLinkHandler} from "./cashier.external-link-handler.interface";
import {OpenCashierOptions} from "../../../../../common/interfaces/cashier.service.interface";
import {
    ExternalLinkInIframeHandlerBase,
    ExternalLinkInIframeRendererParams
} from "../external-link-in-iframe-handler-base";
import {ExternalLinksZIndexes} from "../../external-links-z-indexes";
import {CIPropRead} from "../../../../../utils/case-insensitive-property-reader";
import {GNWP_SOURCES} from "../../../../../sdk/src/components/external_links/external_links_consts";


export class CashierExternalLinkHandler extends ExternalLinkInIframeHandlerBase implements ICashierExternalLinkHandler {

    protected _getGnwpSource(): GNWP_SOURCES {
        return GNWP_SOURCES.CASHIER;
    }

    async openCashier(options?: OpenCashierOptions): Promise<void> {
        if(!await this._ensureUserIsLoggedIn()) {
            return;
        }

        const url = await this._getGnwpUrl(options);
        if(this.services.device.hybrid.inCasino || this.services.device.hybrid.isEmbedded) {
            this.services.hybrid.openExternalLink(url);
        } else if(this.services.device.os.isMobileOS) {
            await this.services.location.redirect(url);
        } else {
            await this._showExternalLinkDialog(url);
        }
    }

    protected async _getGnwpUrl(options?: OpenCashierOptions): Promise<string> {
        return await this.services.gnwp.getCashierUrl({
            target: this.services.device.os.isMobileOS ? 1 : 2, //1 - redirect, 2 = iframe
            sessionType: options?.sessionType,
            promCode: options?.PromCode
        });
    }

    protected _getIframeRendererParams(): ExternalLinkInIframeRendererParams {
        return {
            maxWidth: 1017,
            maxHeight: 686,
            zIndex: ExternalLinksZIndexes.Cashier,
            hideCloseButton: false,
            httpVerb: 'POST',
            analyticsAction: this._getGnwpSource()
        };
    }

    protected async _onPostMessageReceived(message: MessageEvent): Promise<void> {
        if(CIPropRead.getStringProperty('state', this._parseMessageData(message.data))?.toLowerCase() === 'backtogame') {
            this._closeExternalLinkDialog();
        }
    }

}